import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    margin: 20px;
    //max-width: 1190px;
    flex-direction: column;
    position:relative;
    align-items:center;

    

    .inputCargo, .listGroup{
        width: 600px;
        margin-top: 30px;
    }

    .buttonsCargo{
        display: flex;
        margin-top: 35px;
        justify-content:flex-end;
        
        Button{
            margin-left: 10px;
            background-color: var(--blue);
            min-width: 100px;
            border: none;
        }
        
       
    }

    .checkCargo{
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .form-border{
        border-width: 1px;
        border-color: #cccccc;
        border-style: solid;
        padding: 20px;
        border-radius: 2px;
    }
`;

export const CardContainer = styled.div`
    display:flex;
    flex:1;
    align-items:center;
    justify-content:space-between;
    max-width: 800px;
    flex-direction: column;
   
    top:-10px;
    position: relative;
    background-color:#ffffff;
    z-index: 50;
    margin-top: 50px;

    .title{
      background-color: var(--blue);
      color: white;
      width: 100%;
      max-width: 700px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      height: 60px;
   }
`;

export const ViewSubMenu = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    padding-right: 30px;
    padding-left: 30px;
    border-radius: 3px;
    margin-top: 5px;

    :hover{
        background-color: #dddddd;
    }
`;